const SET_WIZARD_STEP = 'SET_WIZARD_STEP';

function setWizardStep(step) {
    return { type: SET_WIZARD_STEP, step };
}

export { SET_WIZARD_STEP, setWizardStep };
